var formatVideoUrl = function(url) {
  const urlArray = url.split('/');
  return "https://www.youtube-nocookie.com/embed/" + urlArray[urlArray.length - 1 ];
};

export default formatVideoUrl;
